// Toast notification — short ephemeral message at top center.
// The DOM element (#toast) is provided by index.html.

let toastEl = null;
let timer = 0;
let announceTimer = 0;
let bossTimer = 0;

function ensureEl() {
  if (toastEl) return toastEl;
  toastEl = document.getElementById('toast');
  return toastEl;
}

/**
 * Show a toast message for `holdMs` (default 1350ms).
 * Re-calling clears the prior timer.
 */
export function showToast(message, holdMs = 1350) {
  const el = ensureEl();
  if (!el) return;
  el.textContent = message;
  el.classList.add('show');
  if (timer) clearTimeout(timer);
  timer = setTimeout(() => el.classList.remove('show'), holdMs);
  showRunAnnouncement(message);
}

/** Clear immediately. */
export function hideToast() {
  const el = ensureEl();
  if (!el) return;
  el.classList.remove('show');
  if (timer) { clearTimeout(timer); timer = 0; }
}

function showRunAnnouncement(message) {
  const text = String(message || '');
  const bossMatch = text.match(/^Boss wave\s+(\d+)/i);
  if (bossMatch) {
    showBossIntro(`Boss Wave ${bossMatch[1]}`);
    return;
  }
  const waveMatch = text.match(/^Wave\s+(\d+)/i);
  if (waveMatch) showAnnouncer(`Wave ${waveMatch[1]}`, waveMatch[1] === '1' ? 'Weapons hot. Safe window active.' : 'Incoming breach. Reposition now.');
}

function showAnnouncer(title, subtitle) {
  const root = document.getElementById('announcer');
  const titleEl = document.getElementById('announceTitle');
  const subEl = document.getElementById('announceSub');
  if (!root || !titleEl || !subEl) return;
  titleEl.textContent = title;
  subEl.textContent = subtitle;
  root.classList.remove('danger', 'hidden');
  if (announceTimer) clearTimeout(announceTimer);
  announceTimer = setTimeout(() => root.classList.add('hidden'), 1550);
}

function showBossIntro(title) {
  const root = document.getElementById('bossIntro');
  const titleEl = document.getElementById('bossIntroTitle');
  if (!root || !titleEl) return;
  titleEl.textContent = title;
  root.classList.remove('hidden');
  if (bossTimer) clearTimeout(bossTimer);
  bossTimer = setTimeout(() => root.classList.add('hidden'), 2200);
}
